import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=46d4a36a&scoped=true&"
import script from "./Achievement.vue?vue&type=script&lang=js&"
export * from "./Achievement.vue?vue&type=script&lang=js&"
import style0 from "./Achievement.vue?vue&type=style&index=0&id=46d4a36a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d4a36a",
  null
  
)

export default component.exports